var text_field_default = {
  "root": "HBj-E",
  "text": "_0SdQ7",
  "input": "_85nVB",
  "small": "aEki-",
  "medium": "oIkCr",
  "large": "T0pmu",
  "webview": "dCBY1",
  "endAdornment": "IvdOs",
  "shown": "_0e-a2",
  "value": "KDbis",
  "spinner": "Zrasf",
  "spin": "Zm-KW"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
